var alignmentStyle = {"alignLeft":"dKLvh","textWrapNowrap":"HIxnR","alignRight":"jRtld","alignCenter":"yPOp-","sizeFullWidth":"NDqbL","renderedInTable":"SsLEJ","sizeOriginal":"PctXd","sizeContent":"pvJB8","sizeSmall":"lTD6A","sizeSmallCenter":"XcILr","flex":"buZyC","LEFT":"UG694","CENTER":"-wZ2t","RIGHT":"jpVT6","AUTO":"_6y8tI","JUSTIFY":"lxnRa"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-bcaa5597.js.map
